<script lang="ts">
    import Alert from "../../alert/Alert.svelte";
    export let type: "text" | "password" | "email" | "number" = "text";
    export let label: string;
    export let name: string;
    export let value: string;
    export let required: boolean = false;
    export let focused: boolean = false;
    export let message:
        | { message: string; type: "error" | "warning" | "notice" | "success" }
        | undefined;
    export let onchange: (value: string, e: Event) => void;
    export let onblur: (e: Event) => void;

    function focusedInput(node: HTMLInputElement, isFocused) {
        if (isFocused) {
            node.focus();
        }
    }
</script>

<div
    class="TextInput form-item form-item--{type}"
    class:form-item--focused={focused}
    class:form-item--required={required}
>
    <label>
        <span class="label">{label}</span>
        <input
            {type}
            {value}
            on:change={(e) => {
                onchange(e.currentTarget.value, e);
            }}
            {required}
            on:focus={() => {
                focused = true;
            }}
            on:blur={(e) => {
                focused = false;
                if (onblur) {
                    onblur(e);
                }
            }}
            {name}
            use:focusedInput={focused}
        />
    </label>
    {#if message}
        <div class="Message">
            <Alert type={message.type} message={message.message} />
        </div>
    {/if}
</div>

<style type="text/scss">
    @import "../../../scss/config.scss";

    .TextInput {
        label {
            display: block;
            background: $color-light-grey;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            padding: 25px 12px 5px;
            position: relative;
            border-bottom: 1px solid $color-base;
            span.label {
                position: absolute;
                top: 8px;
                font-size: 0.85rem;
                color: lighten($color-base, 15%);
            }
        }
        &.form-item--focused {
            label {
                border-bottom: 1px solid $color-primary !important;
            }
        }
        &.form-item--error {
            label {
                border-bottom: 1px solid $color-error;
            }
        }
        &.form-item--success {
            label {
                border-bottom: 1px solid $color-success;
            }
        }
        input {
            background: transparent;
            color: currentColor;
            width: 100%;
            border: 0;
            height: 1.1876em;
            margin: 0;
            display: block;
            padding: 6px 0 7px;
            min-width: 0;
            box-sizing: content-box;
            -webkit-tap-highlight-color: transparent;
            outline: none;
        }
        input:-webkit-autofill,
        input:-webkit-autofill:hover,
        input:-webkit-autofill:focus,
        input:-webkit-autofill:active {
            box-shadow: 0 0 0 30px $color-light-grey inset !important;
            -webkit-box-shadow: 0 0 0 30px $color-light-grey inset !important;
        }
        .Message {
            margin-top: 10px;
        }
    }
</style>
